export type AgeSeries = number[];

const createAgeSeries = (length = 31): AgeSeries => Array(length).fill(0);

export class PineEconomicAnalysisProjection {
  yields: Yields;
  costs: Costs;
  returns: Returns;
  undiscountedCosts: AgeSeries;
  undiscountedReturns: AgeSeries;
  undiscountedCashflow: AgeSeries;
  undiscountedCumulativeCashflow: AgeSeries;
  discountedCosts: AgeSeries;
  discountedReturns: AgeSeries;

  constructor(length: number) {
    this.yields = new Yields(length);
    this.costs = new Costs(length);
    this.returns = new Returns(length);
    this.undiscountedCosts = createAgeSeries(length);
    this.undiscountedReturns = createAgeSeries(length);
    this.undiscountedCashflow = createAgeSeries(length);
    this.undiscountedCumulativeCashflow = createAgeSeries(length);
    this.discountedCosts = createAgeSeries(length);
    this.discountedReturns = createAgeSeries(length);
  }
}

export class Yields {
  accu: AgeSeries;
  largeSawlogs: AgeSeries;
  smallSawlogs: AgeSeries;
  posts: AgeSeries;
  pulplogs: AgeSeries;
  totalLogProducts: AgeSeries;

  constructor(length: number) {
    this.accu = createAgeSeries(length);
    this.largeSawlogs = createAgeSeries(length);
    this.smallSawlogs = createAgeSeries(length);
    this.posts = createAgeSeries(length);
    this.pulplogs = createAgeSeries(length);
    this.totalLogProducts = createAgeSeries(length);
  }
}

export class Costs {
  estAgeZeroFixedCosts: AgeSeries;
  estAgeZeroAreaBasedCosts: AgeSeries;
  postEstAgeOneAreaBasedCosts: AgeSeries;
  postEstAnnualAreaBasedCosts: AgeSeries;
  carbonAgeZeroFixedCosts: AgeSeries;
  carbonAgeOneAuditCosts: AgeSeries;
  carbonAgeSixAuditCosts: AgeSeries;
  carbonAgeElevenAuditCosts: AgeSeries;
  carbonOffsetReportCosts: AgeSeries;
  thinningHarvestCosts: AgeSeries;
  thinningCartageCosts: AgeSeries;
  thinningFixedPlanningCosts: AgeSeries;
  thinningAreaBasedPlanningCosts: AgeSeries;
  thinningRoadingCosts: AgeSeries;
  harvestCosts: AgeSeries;
  harvestCartageCosts: AgeSeries;
  harvestFixedPlanningCosts: AgeSeries;
  harvestAreaBasedPlanningCosts: AgeSeries;
  harvestRoadingCosts: AgeSeries;

  constructor(length: number) {
    this.estAgeZeroFixedCosts = createAgeSeries(length);
    this.estAgeZeroAreaBasedCosts = createAgeSeries(length);
    this.postEstAgeOneAreaBasedCosts = createAgeSeries(length);
    this.postEstAnnualAreaBasedCosts = createAgeSeries(length);
    this.carbonAgeZeroFixedCosts = createAgeSeries(length);
    this.carbonAgeOneAuditCosts = createAgeSeries(length);
    this.carbonAgeSixAuditCosts = createAgeSeries(length);
    this.carbonAgeElevenAuditCosts = createAgeSeries(length);
    this.carbonOffsetReportCosts = createAgeSeries(length);
    this.thinningHarvestCosts = createAgeSeries(length);
    this.thinningCartageCosts = createAgeSeries(length);
    this.thinningFixedPlanningCosts = createAgeSeries(length);
    this.thinningAreaBasedPlanningCosts = createAgeSeries(length);
    this.thinningRoadingCosts = createAgeSeries(length);
    this.harvestCosts = createAgeSeries(length);
    this.harvestCartageCosts = createAgeSeries(length);
    this.harvestFixedPlanningCosts = createAgeSeries(length);
    this.harvestAreaBasedPlanningCosts = createAgeSeries(length);
    this.harvestRoadingCosts = createAgeSeries(length);
  }
}

export class Returns {
  carbonAccuReturns: AgeSeries;
  thinningSmallSawlogsReturns: AgeSeries;
  thinningPostsReturns: AgeSeries;
  thinningPulplogsReturns: AgeSeries;
  harvestLargeSawlogsReturns: AgeSeries;
  harvestSmallSawlogsReturns: AgeSeries;
  harvestPulplogsReturns: AgeSeries;

  constructor(length: number) {
    this.carbonAccuReturns = createAgeSeries(length);
    this.thinningSmallSawlogsReturns = createAgeSeries(length);
    this.thinningPostsReturns = createAgeSeries(length);
    this.thinningPulplogsReturns = createAgeSeries(length);
    this.harvestLargeSawlogsReturns = createAgeSeries(length);
    this.harvestSmallSawlogsReturns = createAgeSeries(length);
    this.harvestPulplogsReturns = createAgeSeries(length);
  }
}
